<div class="schedule-calendar" [class.compact]="compact">
  <!-- Header with navigation -->
  <div class="calendar-header">
    <button class="nav-button" (click)="previousMonth()" aria-label="Previous month">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>
    <div class="month-year">
      <span class="month-name">{{ displayMonth }}</span>
      <span class="year">{{ displayYear }}</span>
    </div>
    <button class="nav-button" (click)="nextMonth()" aria-label="Next month">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>
    <button class="today-button" (click)="goToToday()" *ngIf="highlightToday">
      {{ 'SHARED.Today' | translate }}
    </button>
  </div>

  <!-- Loading indicator -->
  <div class="loading-overlay" *ngIf="loading">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <!-- Calendar grid -->
  <div class="calendar-grid" *ngIf="!loading">
    <!-- Week day headers -->
    <div class="weekday-header">
      <div class="weekday-cell" *ngFor="let day of weekDayHeaders">{{ day }}</div>
    </div>

    <!-- Calendar weeks -->
    <div class="calendar-weeks">
      <div class="calendar-week" *ngFor="let week of weeks">
        <div
          *ngFor="let day of week"
          [class]="getDayClasses(day)"
          (click)="onDayClick(day)"
        >
          <span class="day-number">{{ day.dayOfMonth }}</span>
          <!-- Work time indicator (for work days) -->
          <div class="work-indicator" *ngIf="day.isCurrentMonth && day.workPeriods.length > 0 && !day.isDayOff && !compact">
            <span class="work-time-text" *ngFor="let period of day.workPeriods">
              {{ period.startTime | slice:0:5 }}-{{ period.endTime | slice:0:5 }}
            </span>
          </div>
          <!-- Day off time indicator (for days off) -->
          <div class="day-off-indicator" *ngIf="day.isCurrentMonth && day.isDayOff && day.workPeriods.length > 0 && !compact">
            <span class="day-off-time-text" *ngFor="let period of day.workPeriods">
              {{ period.startTime | slice:0:5 }}-{{ period.endTime | slice:0:5 }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Legend -->
  <div class="calendar-legend" *ngIf="showLegend && !loading">
    <div class="legend-item">
      <span class="legend-color work-time"></span>
      <span class="legend-label">{{ workDaysLabelKey | translate }}</span>
    </div>
    <div class="legend-item">
      <span class="legend-color day-off"></span>
      <span class="legend-label">{{ daysOffLabelKey | translate }}</span>
    </div>
    <div class="legend-item" *ngIf="highlightToday">
      <span class="legend-color today"></span>
      <span class="legend-label">{{ 'SHARED.Today' | translate }}</span>
    </div>
  </div>
</div>
